const AmbientWeatherApi = require('ambient-weather-api/lib/index')

export const api = new AmbientWeatherApi({
    apiKey: 'c86407315228452d8df49a62edd4d64a828790ac45c348ebb07b865fb5c0a6aa',
    applicationKey: '76634cfe6cb04ee49e92be037bf387d66b40b25fd24d481db209318a508d8a8f'
  })
